import type { MouseEvent } from "react";
import { trackCTAClick } from "@/lib/analytics";
import { BOOKING_URL } from "@/lib/tagConfig";

export const bookingHref = BOOKING_URL || "/#contact";
export const bookingTarget = BOOKING_URL ? "_blank" : undefined;

export const handleBookingClick = (
  event: MouseEvent<HTMLAnchorElement>,
  placement: string,
) => {
  trackCTAClick("Book diagnostic call", placement);

  if (BOOKING_URL) return;

  event.preventDefault();
  const contact = document.querySelector("#contact");
  if (contact) {
    contact.scrollIntoView({ behavior: "smooth" });
    return;
  }

  window.location.href = "/#contact";
};